import { createContext } from "react";
import { InitialPlayerCardsContextData, PlayerCardsContext, PlayerCardsContextData } from "./PlayerCardsContext";
import { InitialPreviewContextData, PreviewContext, PreviewContextData } from "./PreviewContext";
import { InitialTemplatesContextData, TemplatesContext, TemplatesContextData } from "./TemplatesContext";
import { InitialToastContextData, ToastContext, ToastContextData } from "./ToastContext";
import { InitialThemesContextData, ThemesContext, ThemesContextData } from "./ThemesContext";
import { InitialPlaceholderContextData, PlaceholderContext, PlaceholderContextData } from "./PlaceholderContext";
import {
  SocialNetworkSettingsContext,
  SocialNetworkSettingsContextData,
  InitialSocialNetworkSettingsContextData,
} from "./SocialNetworkSettingsContext";
import { ContentPageContext, ContentPageContextData, InitialContentPageContextData } from "./ContentPageContext";
import { BlogContext, BlogContextData, InitialBlogContextData } from "./BlogContext";
import { PostContext, PostContextData, InitialPostContextData } from "./PostContext";
import { ReviewContext, ReviewContextData, InitialReviewContextData } from "./ReviewContext";
import { InitialUserContextData, UserContext, UserContextData } from "./UserContext";
import {
  InitialSmartLinkContextData,
  SmartLinkContext,
  SmartLinkContextData,
} from "@/containers/PlayerCardSettings/Contexts/SmartLinkContext";

export interface PlayerCardSettingsData {
  User: UserContextData;
  Preview: PreviewContextData;
  PlayerCards: PlayerCardsContextData;
  Templates: TemplatesContextData;
  Themes: ThemesContextData;
  Toast: ToastContextData;
  Placeholders: PlaceholderContextData;
  SocialNetworkSettings: SocialNetworkSettingsContextData;
  ContentPages: ContentPageContextData;
  Blogs: BlogContextData;
  Posts: PostContextData;
  SmartLinks: SmartLinkContextData;
  Reviews: ReviewContextData;
}

export const PlayerCardSettingsContext = createContext<PlayerCardSettingsData>({
  User: InitialUserContextData,
  Preview: InitialPreviewContextData,
  PlayerCards: InitialPlayerCardsContextData,
  Templates: InitialTemplatesContextData,
  Themes: InitialThemesContextData,
  Toast: InitialToastContextData,
  Placeholders: InitialPlaceholderContextData,
  SocialNetworkSettings: InitialSocialNetworkSettingsContextData,
  ContentPages: InitialContentPageContextData,
  Blogs: InitialBlogContextData,
  Posts: InitialPostContextData,
  SmartLinks: InitialSmartLinkContextData,
  Reviews: InitialReviewContextData,
});

const Context = (): PlayerCardSettingsData => {
  const User = UserContext();
  const Toast = ToastContext();
  const PlayerCards = PlayerCardsContext(Toast);
  const Templates = TemplatesContext(Toast, PlayerCards, User);
  const Themes = ThemesContext(Toast, PlayerCards);
  const Preview = PreviewContext();
  const Placeholders = PlaceholderContext(PlayerCards);
  const SocialNetworkSettings = SocialNetworkSettingsContext(PlayerCards, User);
  const ContentPages = ContentPageContext(PlayerCards, User);
  const Blogs = BlogContext(PlayerCards, User);
  const Posts = PostContext(PlayerCards, User);
  const SmartLinks = SmartLinkContext(PlayerCards, User);
  const Reviews = ReviewContext(PlayerCards, User, Preview);

  return {
    User,
    PlayerCards,
    Templates,
    Themes,
    Preview,
    Toast,
    Placeholders,
    SocialNetworkSettings,
    ContentPages,
    Blogs,
    Posts,
    SmartLinks,
    Reviews,
  };
};

export default Context;
